// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"78842986","453":"543b3a01","948":"dd5973f7"}[chunkId] + ".chunk.js";
};